import { type PropsWithChildren, createContext, useContext } from 'react';

import { BrandFont, PrivateBrandStyles } from 'reservations/brand/types/brand';
import { PreDiningContentModule } from 'reservations/preDining/queries/usePreDiningQuery';
import usePreviewMode from 'reservations/preview/hooks/usePreviewMode';

export interface PreDiningPreviewBrandImage {
  image_path: string;
  alt_text: string;
}

export interface PreviewData {
  brandFonts?: BrandFont[];
  brandStyles?: PrivateBrandStyles;
  brand_image?: PreDiningPreviewBrandImage[];
  pre_dining_message?: string;
  pre_dining_content_modules?: PreDiningContentModule[];
}

export interface PreviewModeDataContextInterface {
  previewData: PreviewData | null;
  isPreview: boolean;
}

export const PreviewModeDataContext =
  createContext<PreviewModeDataContextInterface | null>(null);

const PreviewModeProvider = ({ children }: PropsWithChildren) => {
  const { previewData, isPreview } = usePreviewMode();

  const value = {
    previewData,
    isPreview
  };

  return (
    <PreviewModeDataContext.Provider value={value}>
      {children}
    </PreviewModeDataContext.Provider>
  );
};

export const usePreviewModeContext = () => {
  const context = useContext(PreviewModeDataContext);
  if (context == null) {
    throw new Error(
      'usePreviewModeContext must be used within PreviewModeProvider'
    );
  }

  return context;
};

export default PreviewModeProvider;
